module.exports = __webpack_public_path__ + "media/src/images/logo/logo-1-sp-cdb33bdeab8fac49a8a1da3c1c276fd5.png";